import React from 'react';

import { AppConstants } from '../../../libs/enums';

export const HeaderComponent: React.FC = React.memo(() => (
  <header className="fr-header" role="banner">
    <div className="fr-header__body">
      <div className="fr-container">
        <div className="fr-header__body-row">
          <div className="fr-header__brand fr-enlarge-link">
            <div className="fr-header__brand-top">
              <div className="fr-header__logo">
                <p className="fr-logo">
                  République
                  <br />
                  Française
                </p>
              </div>
              <div className="fr-header__operator">
                <img
                  alt="FranceConnect, 10 ans de simplification de l’accès aux démarches"
                  className="fr-responsive-img"
                  src={`${AppConstants.PUBLIC_URL}/img/fc-logo-10-ans.svg`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
));

HeaderComponent.displayName = 'HeaderComponent';
